import React from 'react';
import {Route, withRouter, Redirect} from 'react-router-dom';
import util from "../../util/util";
import Header from "./tpl_header";

function Default(props) {
    const {component:Component, ...rest} = props;
    if(!util.isLogged()){
        return <Redirect to="/" />;
    }

    return (
      <Route {...rest}  render={()=>{
            return(
                <React.Fragment>
                    <Header {...rest}></Header> 
                    <Component {...rest}  />
                </React.Fragment>
            )
        }} />
    );
}

export default withRouter(Default);